<template>
  <div class="mx-auto mw-700">
    <v-spacer class="mt-2" />
    <h3>
      {{ $t('host.label.serviceHistory') }}
    </h3>
    <v-spacer class="mt-4" />

    <v-data-table
      mobile-breakpoint="20"
      :items="orderServiceHistory"
      :headers="hostServiceHistoryHeaders"
      :no-data-text="$t('appointment.table.noData')"
      :loading-text="$t('appointment.table.loading')"
      :items-per-page="10"
      :footer-props="{
        'items-per-page-text': '',
        'items-per-page-options': [],
      }"
      item-key="index"
      single-expand
      disable-sort
      show-expand
    >
      <template v-slot:[`item.author`]="{ item }">
        <p class="body-2 mb-0">
          {{ item.author.name }}
        </p>
        <span class="caption grey--text">
          {{ item.author.username }}
        </span>
      </template>
      <template v-slot:[`item.date_created`]="{ item }">
        {{ formatDate(item.date_created) }}
      </template>

      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="pa-0 ma-0">
          <div class="pa-5 grey lighten-4">
            <h3 class="mb-3">
              {{ $t('host.label.serviceHistory') }}
            </h3>
            <ul class="body-2 mb-0 list-style-none">
              <li
                v-for="service in item.service_types"
                :key="service"
              >
                {{ $t(`type.${service}`) }}
              </li>
            </ul>
          </div>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters}  from  'vuex'
import { hostServiceHistoryHeaders } from '@/views/listHeaders/hostHeaders'
import { catalogDate } from '@/util/catalog'
import moment from 'moment'

export default {
  name: 'HostServiceHistory',

  computed: {
    ...mapGetters(['host']),

    serviceHistory() {
      return this.host?.service_history
    },

    orderServiceHistory() {
      if (!this.serviceHistory) return []
      return this.serviceHistory.sort((a, b) => moment(b.date_created).diff(moment(a.date_created)))
    },
  },

  data() {
    return {
      hostServiceHistoryHeaders: hostServiceHistoryHeaders,
      formatDate: catalogDate
    }
  }
}
</script>
